import academyListStore from '@modules/academy/academy-list-store';
import academyViewStore from '@modules/academy/academy-view-store';
import academyImporterStore from '@modules/academy/academy-importer-store';
import academyFormStore from '@modules/academy/academy-form-store';
import academyDestroyStore from '@modules/academy/academy-destroy-store';

export default {
  namespaced: true,

  modules: {
    destroy: academyDestroyStore,
    form: academyFormStore,
    list: academyListStore,
    view: academyViewStore,
    importer: academyImporterStore,
  },
};
